export default __webpack_public_path__ + "static/media/2_Eingeschneit.3299c929.png";